export var CardLockTypeEnum;
(function (CardLockTypeEnum) {
    CardLockTypeEnum["ADD_CARD"] = "ADD_CARD";
    CardLockTypeEnum["CARD_DEPOSIT"] = "CARD_DEPOSIT";
})(CardLockTypeEnum || (CardLockTypeEnum = {}));
//# sourceMappingURL=card-lock-type.enum.js.map